<template lang="pug">
#visualizar-monitoramento-agricola(
    v-if='monitoramento && dadosMonitoramentoAgro'
)
    BaseHeader(
        :titulo='territorio.nome',
        :exibeBotao='false',
        :voltarPara='voltarPara',
        icon='mdi mdi-file-download ',
        :btnTexto="$t('mensagens.monitoramentoAgricola.visualizarImovel.baseHeader.botao')"
    )
    .paddingCondicional
        el-tabs(v-model="abaAtual", @tab-click="handleTabClick" class="custom-tabs")
            el-tab-pane(
                :label="$t('mensagens.monitoramentoAgricola.visualizarImovel.switch.inativo')",
                name="monitoramento"
            )
            el-tab-pane(
                :label="$t('mensagens.monitoramentoAgricola.visualizarImovel.switch.ativo')",
                name="historico"
            )
    .view-container.bloco-dataSecao(v-if='abaAtual === "historico"')
        Historico(
            :dadosAreaMonitorada='monitoramento',
            :altura='90',
            :isHorizontal='true'
        )
    .view-container.bloco-dataSecao(v-if='abaAtual === "monitoramento"')
        BlocoAlertaVisualizarMonitoramentoAgricola(
            :codigoAreaMonitorada='monitoramento.codigoVegaAPI'
        )
        .bloco-dataSecao--container
            h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoDataAcao.titulo') }}
            .bloco-dataSecao--container--interno
                BlocoDataAcaoMonitoramentoAgricola(
                    :titulo="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoDataAcao.ultimaVisita')",
                    :valor='dadosPlantio.ultimaVisita ? dadosPlantio.ultimaVisita.dataVisita : "-"'
                )
                BlocoDataAcaoMonitoramentoAgricola(
                    :titulo="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoDataAcao.dadosDeReferencia')",
                    :valor='dadosPlantio.ultimaVisita ? dadosPlantio.ultimaVisita.dataImagem : "-"'
                )
                BlocoDataAcaoMonitoramentoAgricola(
                    :titulo="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoDataAcao.ultimaAtualizacao')",
                    :valor='dadosPlantio.dataUltimoProcessamento ? dadosPlantio.dataUltimoProcessamento : "-"'
                )

        .bloco-dataSecao--container
            h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.titulo') }}
            .bloco-dataSecao--container--interno
                BlocoAreaPlantadaProdutividadeMonitoramentoAgricola(
                    :titulo="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.areaPlantada')",
                    :subtitulo="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.analiseDeArea')",
                    :valorInformado='dadosAreasPlantadas.informada',
                    :valorMonitorado='dadosAreasPlantadas.monitorada',
                    :exibir-valor-divergente='false'
                    :divergencia='dadosAreasPlantadas.divergencia'
                    :iconeDivergencia='dadosAreasPlantadas.divergencia ? "mdi mdi-alert-outline" : "mdi mdi-check-circle-outline"'
                )
                BlocoSituacaoMonitoramentoAgricola(
                    icone='mdi mdi-calendar-month',
                    :titulo="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.dataPlantio')",
                    :descricaoEsquerda="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.dataInformada')",
                    :valorEsquerdo='dadosDataPlantio.informada',
                    :descricaoDireita="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.dataIdentificada')",
                    :valorDireito='dadosDataPlantio.monitorada',
                    :iconeDivergencia='dadosDataPlantio.divergencia ? "mdi mdi-alert-outline" : "mdi mdi-check-circle-outline"',
                    :divergencia='dadosDataPlantio.divergencia'
                )
                BlocoSituacaoMonitoramentoAgricola(
                    icone='lyra-icon lyra-planta',
                    :titulo="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.cultura')",
                    :descricaoEsquerda="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.culturaInformada')",
                    :valorEsquerdo='internacionalizarCulturas(dadosCultura.informada)',
                    :descricaoDireita="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.culturaMonitorada')",
                    :valorDireito='dadosCultura.monitorada',
                    :iconeDivergencia='dadosCultura.divergencia ? "mdi mdi-alert-outline" : "mdi mdi-check-circle-outline"'
                    :divergencia='dadosCultura.divergencia'
                )
                BlocoAreaPlantadaProdutividadeMonitoramentoAgricola(
                    :titulo="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.produtividade')",
                    :subtitulo='internacionalizarSubtitulo(produtividade.titulo)',
                    :valorInformado='produtividade.informada',
                    :valorMonitorado='produtividade.monitorada',
                    :valorDivergente='produtividade.percentualDivergencia',
                    :divergencia='produtividade.divergencia',
                    :iconeDivergencia='produtividade.divergencia ? "mdi mdi-alert-outline" : "mdi mdi-check-circle-outline"',
                    :exibir-paginacao='paginacao',
                    :pagina-atual='produtividade.index + 1'
                    :pagina-final='dadosProdutividade.length'
                    @pagina-anterior='paginaAnterior',
                    @pagina-seguinte='paginaSeguinte'
                )

        .dados-territorio-monitoramento__container
            .dados-territorio-monitoramento-dados
                .dados-territorio-monitoramento-dados-item
                    h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.dadosTerritorio') }}
                    BlocoDadosTerritorioMonitoramentoAgricola(
                        :monitoramento='monitoramento'
                    )
                .dados-territorio-monitoramento-dados-item
                    h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.carsVinculados') }}
                    BlocoDadosCarVinculadosMonitoramentoAgricola(
                        :cars='monitoramento.carsApi',
                        :monitoramento='monitoramento'
                    )
                .dados-territorio-monitoramento-dados-item(v-show='false')
                    h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.informacoesAdicionais') }}
                    BlocoInformacoesAdicionaisMonitoramento(
                        :operacoes='operacoes'
                    )

        .carrosel-clima__container
            h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.previsaoClimatica') }}
            CarroselClimaMonitoramentoAgricola

        .tabs_mapa__container
            h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.selecioneCulturaParaVisualizarDadosMonitoramento') }}
            BlocoTabsMapaMonitoramentoAgricola(
                :monitoramento='monitoramento',
                :monitoramentoAgro='dadosMonitoramentoAgro',
                :dadosPlantio='dadosPlantio'
            )

        .bloco-ndvi
            el-row.info-selecao-grafico
                h3.info-selecao-texto {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoNdvi.tituloGrafico') }}
                el-select(v-if='culturaAtual === "SOJA"' v-model="codigoAcuracia" placeholder="Selecione a Acurácia Desejada" style="width: 240px")
                    el-option(
                        v-for="item in listaAcuracias"
                        :key="item.value"
                        :label="internacionalizarAcuracia(item.codigo)"
                        :value="item.codigo"
                    )
                        div(:style='{ "display": "flex", "align-items": "center" }')
                            div(
                                :style='{ "background-color": item.value, "margin-right": "10px", "width": "20px", "height": "20px", "border-radius": "3px" }'
                                size="small"
                                :round=false
                            )
                            span(:style='{ "margin-top": "4px"}') {{ internacionalizarAcuracia(item.codigo) }}

            card(
                :info="$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoNdvi.infoGrafico')"
            )
                grafico-evolucao-indice-vegetacao(
                    :dadosMonitoramentoNDVI='dadosAcuraciaSelecionada',
                    v-if='dadosMonitoramentoAgro'
                )

        .bloco-historico-monitoramento(style='display: none')
            .bloco-historico-monitoramento__historico
                .bloco-historico-monitoramento__header
                    .bloco-historico-monitoramento__titulo
                        h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoHistoricoMonitoramento.titulo') }}
                        h4 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoHistoricoMonitoramento.subtitulo') }}
                .bloco-historico-monitoramento__lista
                    TimelineHistoricoMonitoramento(
                        :dados='historicosMonitoramento'
                    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoAlertaVisualizarMonitoramentoAgricola from '@/components/monitoramento/BlocoAlertaVisualizarMonitoramentoAgricola';
import BlocoDataAcaoMonitoramentoAgricola from '@/components/monitoramento/BlocoDataAcaoMonitoramentoAgricola';
import BlocoSituacaoMonitoramentoAgricola from '@/components/monitoramento/BlocoSituacaoMonitoramentoAgricola';
import BlocoAreaPlantadaProdutividadeMonitoramentoAgricola from '@/components/monitoramento/BlocoAreaPlantadaProdutividadeMonitoramentoAgricola';
import BlocoDadosTerritorioMonitoramentoAgricola from '@/components/monitoramento/BlocoDadosTerritorioMonitoramentoAgricola';
import BlocoInformacoesAdicionaisMonitoramento from '@/components/monitoramento/BlocoInformacoesAdicionaisMonitoramento';
import CarroselClimaMonitoramentoAgricola from '@/components/monitoramento/CarroselClimaMonitoramentoAgricola';
import BlocoTabsMapaMonitoramentoAgricola from '@/components/monitoramento/BlocoTabsMapaMonitoramentoAgricola';
import TimelineHistoricoMonitoramento from '@/components/monitoramento/TimelineHistoricoMonitoramento';
import Historico from '@/components/areamonitorada/Historico';
import BlocoDadosCarVinculadosMonitoramentoAgricola from '@/components/monitoramento/BlocoDadosCarVinculadosMonitoramentoAgricola';
import GraficoEvolucaoIndiceVegetacao from '@/components/areamonitorada/graficos/GraficoEvolucaoIndiceVegetacao';
import Card from '@/components/Card';

import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import MonitoramentoService from '@/services/MonitoramentoService';
import HistoricoService from '@/services/HistoricoService';
import TipoMonitoramento from '@/constants/TipoMonitoramento';
import EventBus from '@/utils/eventBus';

import { CodigoAcuracia } from '../../../constants/AcuraciaEnum';

export default {
    name: 'VisualizarImovelMonitoramentoAgricola',
    components: {
        BaseHeader,
        BlocoAlertaVisualizarMonitoramentoAgricola,
        BlocoDataAcaoMonitoramentoAgricola,
        BlocoSituacaoMonitoramentoAgricola,
        BlocoAreaPlantadaProdutividadeMonitoramentoAgricola,
        BlocoDadosTerritorioMonitoramentoAgricola,
        BlocoInformacoesAdicionaisMonitoramento,
        CarroselClimaMonitoramentoAgricola,
        BlocoTabsMapaMonitoramentoAgricola,
        TimelineHistoricoMonitoramento,
        Historico,
        BlocoDadosCarVinculadosMonitoramentoAgricola,
        GraficoEvolucaoIndiceVegetacao,
        Card
    },
    data() {
        return {
            paginacao: false,
            produtividade: {
                index: 0,
                informada: '-',
                monitorada: '-',
                percentualDivergencia: '-',
                divergencia: false,
                titulo: this.$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.analiseProducao'),
                cultura: '-'
            },
            operacoes: ['OP1', 'OP 2', 'oPE 3'],
            voltarPara: {
                route: 'MonitoramentoAgricola'
            },
            idAreaMonitorada: this.$route.params.id,
            monitoramento: null,
            territorio: null,
            dadosMonitoramentoAgro: null,
            historicosMonitoramento: [],
            dadosPlantioCarregados: false,
            dadosPlantio: {
                areasPlantadas: [],
                dataConsulta: '-',
                dataUltimoProcessamento: '-',
                ultimaVisita: '-'
            },
            dadosDataPlantio: {
                informada: '-',
                monitorada: '-',
                divergencia: false
            },
            dadosCultura: {
                informada: '-',
                monitorada: '-',
                divergencia: false
            },
            dadosAreasPlantadas: {
                informada: '-',
                monitorada: '-',
                divergencia: false
            },
            dadosProdutividade: [],
            abaAtual: 'monitoramento',
            culturaAtual: '',
            dadosAcuraciaSelecionada: [],
            codigoAcuracia: '',
            listaAcuracias: [
                {
                    value: 'var(--acuracia-oitenta-color)',
                    codigo: CodigoAcuracia.ACURACIA80
                },
                {
                    value: 'var(--acuracia-cinquenta-oitenta-color)',
                    codigo: CodigoAcuracia.ACURACIA51A80
                },
                {
                    value: 'var(--acuracia-cinquenta-color)',
                    codigo: CodigoAcuracia.ACURACIA50
                }
            ],
            dadosGraficoSojaMaior80: [],
            dadosGraficoSoja50e80: [],
            dadosGraficoSojaMenor50: []
        };
    },
    async mounted() {
        EventBus.$on(
                    'emit-change-cultura',
                    async (listaCodigosAcuracia, culturaSelecionada) => {
                        this.codigoAcuracia = '';
                        this.culturaAtual = culturaSelecionada;
                        await this.fetchDadosGraficoNdvi(listaCodigosAcuracia);
                    }
                );
        await this.fetchAreaMonitorada();
        await this.fetchDadosPlantio();
        await this.fetchDadosMonitoramento();
        await this.buscarMonitoramento();
        this.exibirPaginacao();
        this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'VISUALIZAR_M_AGRICOLA', pageTitle: 'VISUALIZAR_M_AGRICOLA', routeName: this.$route?.name, routePath: this.$route?.path });
    },
    watch: {
        codigoAcuracia() {
            this.dadosAcuraciaSelecionada = [];
            if (this.codigoAcuracia === CodigoAcuracia.ACURACIA80) {
                this.dadosAcuraciaSelecionada = this.dadosGraficoSojaMaior80;
            } else if (this.codigoAcuracia === CodigoAcuracia.ACURACIA51A80) {
                this.dadosAcuraciaSelecionada = this.dadosGraficoSoja50e80;
            } else if (this.codigoAcuracia === CodigoAcuracia.ACURACIA50) {
                this.dadosAcuraciaSelecionada = this.dadosGraficoSojaMenor50;
            }
        },
        monitoramento() {
            if (
                this.monitoramento &&
                this.dadosMonitoramentoAgro &&
                this.dadosPlantioCarregados
            ) {
                this.montarDados();
            }
        },
        dadosMonitoramentoAgro() {
            if (
                this.monitoramento &&
                this.dadosMonitoramentoAgro &&
                this.dadosPlantioCarregados
            ) {
                this.montarDados();
            }
        },
        dadosPlantioCarregados() {
            if (
                this.monitoramento &&
                this.dadosMonitoramentoAgro &&
                this.dadosPlantioCarregados
            ) {
                this.montarDados();
            }
        }
    },
    methods: {
        handleTabClick(tab) {
            this.abaAtual = tab.paneName;
        },
        exibirPaginacao() {
            this.paginacao = this.dadosProdutividade.length > 1;
            this.produtividade = this.dadosProdutividade[0];
            this.produtividade.index = 0;
        },
        paginaSeguinte() {
            let quantidadeDeProdutividade = this.dadosProdutividade.length - 1;
            let indexAtual = this.produtividade.index;
            if (this.produtividade.index < quantidadeDeProdutividade) {
                let indexSeguinte = indexAtual + 1;
                this.produtividade = this.dadosProdutividade[indexSeguinte];
                this.produtividade.index = indexSeguinte;
            }
        },
        paginaAnterior() {
            let indexAtual = this.produtividade.index;
            let indexDoMeio = 1;
            if (this.produtividade.index >= indexDoMeio) {
                let indexAnterior = indexAtual - indexDoMeio;
                this.produtividade = this.dadosProdutividade[indexAnterior];
                this.produtividade.index = indexAnterior;
            }
        },
        async buscarMonitoramento() {
            try {
                const {data} =
                    await MonitoramentoAgricolaService.buscarSituacaoAreaMonitoradaPorId(
                        this.idAreaMonitorada
                    );
                this.dadosDataPlantio = data.dadosPlantio;
                this.dadosCultura = data.cultura;
                this.dadosAreasPlantadas = data.areaPlantada;
                this.dadosProdutividade = data.produtividades;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.monitoramentoAgricola.erros.buscarMonitoramento')
                });
            }
        },
        async fetchAreaMonitorada() {
            try {
                const { data } =
                    await MonitoramentoAgricolaService.buscarAreaMonitoradaPorId(
                        this.idAreaMonitorada
                    );
                this.monitoramento = data;
                this.territorio = data.territorio;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.monitoramentoAgricola.erros.buscarMonitoramento')
                });
            }
        },
        async fetchDadosPlantio() {
            try {
                const { data } = await MonitoramentoService.dadosPlantio(
                    this.idAreaMonitorada
                );
                this.dadosPlantio = data;
                this.dadosPlantioCarregados = true;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.fetchDadosPlantio'
                    )
                });
            }
        },
        async fetchDadosGraficoNdvi(listaCodigosAcuracia) {
            try {
                this.dadosAcuraciaSelecionada = [];
                const { data } = await MonitoramentoAgricolaService.atualizaGraficoNdvi(
                    this.idAreaMonitorada, listaCodigosAcuracia
                );
                this.dadosMonitoramentoAgro.monitoramentoNDVI = data;

                if (listaCodigosAcuracia.includes(CodigoAcuracia.ACURACIA50) || listaCodigosAcuracia.includes(CodigoAcuracia.ACURACIA51A80) || listaCodigosAcuracia.includes(CodigoAcuracia.ACURACIA80)) {
                    data.map((item) => {

                        if ([CodigoAcuracia.ACURACIA50, CodigoAcuracia.ACURACIA51A80, CodigoAcuracia.ACURACIA80].includes(item.codigoAcuracia)) {

                            if (item.codigoAcuracia === CodigoAcuracia.ACURACIA50) {
                                this.dadosGraficoSojaMenor50.push(item);
                            }
                            if (item.codigoAcuracia === CodigoAcuracia.ACURACIA51A80) {
                                this.dadosGraficoSoja50e80.push(item);
                            }
                            if (item.codigoAcuracia === CodigoAcuracia.ACURACIA80) {
                                let obj = {
                                    codigoAcuracia: item.codigoAcuracia,
                                    dataProcessamento: item.dataProcessamento,
                                    ndviPercentual: item.ndviPercentual
                                };
                                this.dadosGraficoSojaMaior80.push(obj);
                            }

                        }
                    });

                    if (Object.keys(this.dadosGraficoSojaMaior80).length > 0) {
                        this.codigoAcuracia = CodigoAcuracia.ACURACIA80;
                    } else if (Object.keys(this.dadosGraficoSoja50e80).length > 0) {
                        this.codigoAcuracia = CodigoAcuracia.ACURACIA51A80;
                    } else if (Object.keys(this.dadosGraficoSojaMenor50).length > 0) {
                        this.codigoAcuracia = CodigoAcuracia.ACURACIA50;
                    } else {
                        this.codigoAcuracia = '';
                    }
                } else {
                    this.dadosAcuraciaSelecionada = data;
                }
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.fetchDadosGraficoNdvi'
                    )
                });
            }
        },
        async fetchDadosMonitoramento() {
            try {
                const { data } = await MonitoramentoService.monitoramentoAgro(
                    this.idAreaMonitorada
                );
                    this.dadosMonitoramentoAgro = data;
            } catch (e) {
                this.$notify.error({
                    message:
                        this.$t('mensagens.monitoramentoAgricola.erros.fetchDadosMonitoramento')
                });
            }
        },
        async fetchHistoricosMonitoramento() {
            try {
                const { data } =
                    await HistoricoService.buscarHistoricoMonitoramentoPorAreaMonitoradaId(
                        this.idAreaMonitorada
                    );

                data.forEach(historico => {
                    this.historicosMonitoramento.push({
                        ...historico,
                        tipoMonitoramento: TipoMonitoramento.AGRICOLA,
                        territorio: this.territorio,
                        color: historico.possuiRestricao
                            ? 'var(--warning)'
                            : '#09413C'
                    });
                });
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.monitoramentoAgricola.erros.buscarMonitoramento')
                });
            }
        },
        async montarDados() {
            await this.buscarMonitoramento();
            await this.fetchHistoricosMonitoramento();
        },
        internacionalizarCulturas(cultura) {
            const culturaFormatada = cultura.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
            const culturaFormatadaSemEspacos = culturaFormatada.replace(/\s+/g, '-');
            return this.$t(`mensagens.cultura.${culturaFormatadaSemEspacos}`);
        },
        internacionalizarSubtitulo(titulo) {
            if (titulo === 'Análise de produção (sc/ha):') {
                return this.$t(`mensagens.monitoramentoAgricola.analiseDeProducao`);
            } else {
                return titulo;
            }
        },
        internacionalizarAcuracia(acuracia) {
            if (acuracia === CodigoAcuracia.ACURACIA80) {
                return this.$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoNdvi.acuracia80');
            } else if (acuracia === CodigoAcuracia.ACURACIA51A80) {
                return this.$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoNdvi.acuracia50e80');
            } else if (acuracia === CodigoAcuracia.ACURACIA50) {
                return this.$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoNdvi.acuracia50');
            }
        }
    }
};
</script>

<style lang="scss">
#visualizar-monitoramento-agricola {
    .bloco-dataSecao {
        margin-top: 20px;
        margin-bottom: 20px;
        .bloco-dataSecao--container {
            margin-top: 20px;
        }
        .bloco-dataSecao--container--interno {
            display: flex;
            justify-content: space-between;
            margin-top: 7px;
        }
    }

    .dados-territorio-monitoramento__container {
        margin: 18px 5px 10px 5px;

        h3 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
        }
        .dados-territorio-monitoramento-dados {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;

            .dados-territorio-monitoramento-dados-item {
                max-height: 272px;
                width: 49.25%;

                &:last-child {
                    margin: 2px 0px;
                }
            }
        }
    }
    .carrosel-clima__container,
    .tabs_mapa__container {
        margin-top: 18px;

        h3 {
            margin-bottom: 13px;
            margin-top: 10px;
            color: var(--black);
        }
    }

    .bloco-ndvi {
        margin-top: 18px;

        h3 {
            margin-bottom: 13px;
            margin-top: 10px;
            color: var(--black);
        }
    }

    .bloco-historico-monitoramento {
        display: flex;
        margin-top: 25px;
        .bloco-historico-monitoramento__historico {
            width: 100%;
            padding: 0px 10px 0px 0px;
            .bloco-historico-monitoramento__header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                .bloco-historico-monitoramento__icone {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    width: 24px;
                    height: 25px;
                    background-color: var(--white);
                    padding: 17px;
                    border-radius: 5px;
                    box-shadow: 0px 1px 4px rgb(187 187 187);
                }
            }
            .bloco-historico-monitoramento__lista {
                background: var(--white);
                margin: 2px 3px 2px 2px;
                box-shadow: 0px 0px 2px 0px var(--block-shadow);
                border-radius: 5px;
                border: 1px solid var(--default-border-color);
                overflow-y: auto;
                height: 445px;
            }
        }

        h3 {
            margin-bottom: 0px;
            color: var(--black);
            font-weight: 500;
        }
    }

    .paddingCondicional {
        display: flex;
        justify-content: left;
        padding-top: 20px;
    }

    .custom-tabs {
        width: 100%;
        padding: 0px 20px;
        .el-tabs__header {
            border-bottom: -1px solid #8a8a8a;
            margin-bottom: 0;
        }

        .el-tabs__item {
            color: #333;

            &.is-active {
                color: #359138;
            }
        }

        .el-tabs__active-bar {
            background-color: #359138;
            height: 2px;
        }
    }

    .info-selecao-grafico {
        display: flex;
        margin-top: 20px;
    }

    .info-selecao-texto {
        margin-right: 10px;
    }

}
@media only screen and (max-width: 1351px) {
    .dados-gerais-monitoramento__lista h3 {
        min-width: 49.25% !important;
    }
}
</style>
